import { render, staticRenderFns } from "./intelligentvideosurveillanceSystem.vue?vue&type=template&id=23750cec&scoped=true"
import script from "./intelligentvideosurveillanceSystem.vue?vue&type=script&lang=js"
export * from "./intelligentvideosurveillanceSystem.vue?vue&type=script&lang=js"
import style0 from "./intelligentvideosurveillanceSystem.vue?vue&type=style&index=0&id=23750cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23750cec",
  null
  
)

export default component.exports